<ng-container
  *ngFor="let product of project.products; let index = index; let count = count"
>
  <mat-card
    *ngIf="product.type != null"
    class="top-card mat-elevation-z0 overflowHidden"
  >
    <div
      *ngIf="product.type !== PRODUCT_TYPES.IP_BOARD.value && count > 1"
      class="projectTitle"
    >
      {{ product.type | productType: product.otherProductName }}
      <span>#{{ index + 1 }}</span>
    </div>
    <ng-container *ngIf="product.type !== 'IPBoard'">
      <design-picker
        [inputProduct]="product"
        [inputProject]="project"
        [client]="client"
        (updateProduct)="updateDesignAssets(index)"
      >
      </design-picker>
    </ng-container>
    <ng-container *ngIf="product.type === 'IPBoard'">
      <ip-board-design-picker
        [ipBoard]="product"
        [project]="project"
        [client]="client"
        (save)="save.emit(); updateDesignAssets(index)"
      ></ip-board-design-picker>
    </ng-container>
  </mat-card>
</ng-container>
